module.exports = __webpack_public_path__ + "static/media/company-name.33863ffb.svg";